import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  Text,
  VStack,
  HStack,
  Icon,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Box,
} from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  /** Request the pending maatwerk quotes and finish */
  onConfirm: () => void;
  /** Finish without requesting */
  onSkip: () => void;
  pendingMaatwerkCount: number;
}

const AnvaMaatwerkConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  onSkip,
  pendingMaatwerkCount,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <HStack spacing="2">
            <Icon name="GeneralStatusWarningTriangle" color="primary.main" />
            <Text>{t('FLOWS_PRODUCTS_MAATWERK_MODAL_TITLE')}</Text>
          </HStack>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack align="stretch" spacing="4">
            <Alert status="info">
              <AlertIcon />
              <VStack align="stretch" spacing="2" flex={1}>
                <AlertTitle>
                  {t('FLOWS_PRODUCTS_MAATWERK_MODAL_COUNT', {
                    count: pendingMaatwerkCount,
                  })}
                </AlertTitle>
                <AlertDescription>
                  {t('FLOWS_PRODUCTS_MAATWERK_MODAL_DESCRIPTION')}
                </AlertDescription>
              </VStack>
            </Alert>

            {/* Enhanced explanation for brokers */}
            <Box bg="gray.50" p="4" borderRadius="md">
              <VStack align="stretch" spacing="2">
                <HStack spacing="2">
                  <Icon
                    name="GeneralStatusInfo"
                    color="primary.main"
                    boxSize="4"
                  />
                  <Text fontSize="sm" fontWeight="medium">
                    {t('FLOWS_PRODUCTS_MAATWERK_WHY_SEPARATE')}
                  </Text>
                </HStack>
                <Text fontSize="sm" color="gray.600">
                  {t('FLOWS_PRODUCTS_MAATWERK_EXPLANATION')}
                </Text>
              </VStack>
            </Box>

            <Text fontSize="sm" color="gray.600">
              {t('FLOWS_PRODUCTS_MAATWERK_MODAL_CHOOSE')}
            </Text>

            <VStack align="stretch" spacing="2" pl="4">
              <Text fontSize="sm">
                • {t('FLOWS_PRODUCTS_MAATWERK_MODAL_OPTION_REQUEST')}
              </Text>
              <Text fontSize="sm">
                • {t('FLOWS_PRODUCTS_MAATWERK_MODAL_OPTION_SKIP')}
              </Text>
            </VStack>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <HStack spacing="3">
            <Button variant="ghost" onClick={onSkip}>
              {t('FLOWS_PRODUCTS_MAATWERK_FINISH_WITHOUT_REQUEST')}
            </Button>
            <Button variant="primary" onClick={onConfirm}>
              {t('FLOWS_PRODUCTS_MAATWERK_REQUEST_AND_FINISH')}
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AnvaMaatwerkConfirmationModal;
